<template>
  <div class="propetyPage" v-if="!this.showLoad">
    <van-cell-group class="baseNone baseSalary">
      <van-cell 
        title="编号" 
        v-model="propertyData.materialCode" 
        class="ggInput" />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell 
        title="名称" 
        v-model="propertyData.materialName" 
        class="ggInput" />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary" v-if="propertyData.materialTypeName!=null">
      <van-cell 
        title="类型" 
        v-model="propertyData.materialTypeName" 
        class="ggInput" />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell 
        title="单位" 
        v-model="propertyData.unit" 
        class="ggInput" />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell 
        title="单价" 
        v-model="propertyData.price" 
        class="ggInput" />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell 
        title="领用人" 
        v-model="propertyData.applicantName" 
        class="ggInput" />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell 
        title="所属部门" 
        v-model="propertyData.departmentName" 
        class="ggInput" />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary" v-if="propertyData.status!=null">
      <van-cell 
        title="状态" 
        v-model="propertyData.status" 
      class="ggInput" />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell 
        title="领用数量" 
        v-model="propertyData.receiveAmount" 
        class="ggInput" />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-cell 
        title="领用时间" 
        v-model="propertyData.createTime" 
        class="ggInput" />
    </van-cell-group>
    <van-cell-group class="summaryBox baseNone">
      <van-field
        v-model="propertyData.reason"
        rows="1"
        autosize
        label="领用原因"
        type="textarea"
        class="summary"
      />
    </van-cell-group>
    <!-- 审批流程列表   查看编辑时显示 -->
    <!--<div class="approveList" v-if="this.commonType == 'edit'">
      <audit-list :applicantData="appData"></audit-list>
    </div>-->
    <!-- 审批流程图   查看编辑时显示 -->
    <!-- <div class="flowList" v-if="this.postType == 'edit'">
          <flow-list :workflowCode="workflowCode"></flow-list> 
    </div>-->
  </div>
</template>
<script>
/* eslint-disable */
import newApi from "lodash";
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
import { mapState, mapMutations } from "vuex";
export default {
  name: "propertyDetail",
  data() {
    return {
      commonId: "", //资产性情Id
      commonType: "",
      propertyData: {
        materialCode: "", //物资编号
        materialName: "", //物资名称
        materialNature: "", //物资性质
        materialTypeName: "", //物资类型
        unit: "", //单位
        price: "", //单价
        receiveAmount: "", //领用数量
        reason: "", //领用原因
        receiveTime: "", //领用时间
        applicantName: "", //领用人名称
        departmentName: "", //所属部门
        isReturn: "", //是否归还
        status: "" //状态：未借用、借用中、已归还
      }
    };
  },
  created() {
    document.title = "资产管理详情";
  },
  mounted() {
    this.$nextTick(() => {
    this.commonType = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.commonId = this.$route.query.commonId; //申请Id
    window.editPage = this.editPage; //编辑页面
    window.setFile = this.setFiles; //app返回附件回调
    this.setShowLoad(false);
      if (this.commonType == "edit") {
        this.initPage();
      } else {
        this.editType = true;
      }
    });
  },
  components: {
    flowList,
    auditList
  },
  methods: {
    ...mapMutations(["setShowLoad","setAppData"]),

    initPage() {
      let _this = this;
      _this.$api.administration.administration.materialApply.details(_this.commonId).then(res => {
          if (res.code == "1" && res.data !=null) {
            /*_this.propertyData = newApi.assign(
              {},
              _this.propertyData,
              res.data
            );
            _this.propertyData.createTime = _this.propertyData.createTime.substr(
              0,
              10
            );
            _this.appData = newApi.assign({}, _this.appData, res.data);*/
            _this.propertyData = res.data
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch(err => {
          _this.$toast(err);
        });
    }
  },
  computed: {
    ...mapState(["showLoad", "userinfo"])
  }
};
</script>
<style lang="less">
.propetyPage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  font-family: " PingFangSC-Medium", "PingFang SC";
  padding-top: 12px;
  .ggInput {
    height: 45px;
    .van-cell__title {
      span {
        color: #000;
        font-size: 16px;
      }
    }
    .van-cell__value {
      span {
        color: #aaa;
        font-size: 16px;
      }
    }
    .van-cell__right-icon {
      color: #000;
      margin-left: 8px;
    }
  }
  .ggMargin {
    margin-top: 12px;
  }
  .baseNone::after {
    content: none;
  }
  .baseSalary {
    margin-bottom: 2px;
    height: 45px;
    line-height: 45px;
  }
  .summaryBox {
    min-height: 45px;
    padding-top: 10px;
    margin-bottom: 2px;
    p {
      padding: 0 16px;
      font-size: 14px;
      line-height: 24px;
    }
    .van-cell__title {
      span {
        color: #000;
        font-size: 16px;
      }
    }
    .van-cell__value {
      .van-field__control {
        color: #aaa;
        font-size: 16px;
      }
    }
    .summary {
      padding-top: 0;
      .van-field__control {
        text-align: right;
      }
    }
  }
}
</style>